import { render, staticRenderFns } from "./PowerAppV3.vue?vue&type=template&id=65714bbd"
import script from "./PowerAppV3.vue?vue&type=script&lang=js"
export * from "./PowerAppV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports